var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "rb-newsletter-modal-content-success-form rb-cms-registration-form--dark-mode",
    },
    [
      _c(
        "div",
        {
          staticClass: "rb-fieldrow rb-fieldrow-select rb-fieldrow-selects",
          class: {
            "rb-invalidrow": _vm.$v.validationGroup.$error,
            "rb-validrow": _vm.validationGroup,
          },
        },
        [
          _c("label", { staticClass: "rb-fieldrow__helper" }, [
            _vm._v(_vm._s(_vm.translation("registration.date_birth")) + ":"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "rb-select-ddmmyyyy-splitter" },
            [
              _vm._l(_vm.dateOfBirthConfiguration, function (config) {
                return [
                  _c("div", { key: config, staticClass: "rb-select-holder" }, [
                    config === _vm.DAY
                      ? _c(
                          "div",
                          [
                            _c("rb-custom-select", {
                              attrs: {
                                id: "dayOfBirth",
                                name: "dayOfBirth",
                                placeholder: _vm.translation(
                                  "registration.day_birth"
                                ),
                                options: _vm.daysList,
                                validation: _vm.$v.dayOfBirth,
                              },
                              on: { selectedValue: _vm.onSelectedValue },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    config === _vm.MONTH
                      ? _c(
                          "div",
                          {
                            staticClass: "rb-select-wrapper__custom",
                            attrs: { id: "month-select" },
                          },
                          [
                            _c("rb-custom-select", {
                              attrs: {
                                id: "monthOfBirth",
                                name: "monthOfBirth",
                                placeholder: _vm.translation(
                                  "registration.month_birth"
                                ),
                                options: _vm.monthsList,
                                validation: _vm.$v.monthOfBirth,
                              },
                              on: { selectedValue: _vm.onSelectedValue },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    config === _vm.YEAR
                      ? _c(
                          "div",
                          [
                            _c("rb-custom-select", {
                              attrs: {
                                id: "yearOfBirth",
                                name: "yearOfBirth",
                                placeholder: _vm.translation(
                                  "registration.year_birth"
                                ),
                                options: _vm.yearsList,
                                validation: _vm.$v.yearOfBirth,
                              },
                              on: { selectedValue: _vm.onSelectedValue },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "rb-fieldrow__helper-container" }, [
            !_vm.isDobAboveCutoffAge
              ? _c(
                  "div",
                  {
                    staticClass:
                      "rb-fieldrow__helper rb-fieldrow__helper--error",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.translation("registration.minimumAge")) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isDobAboveCutoffAge && _vm.isGenericAlert
              ? _c(
                  "div",
                  {
                    staticClass:
                      "rb-fieldrow__helper rb-fieldrow__helper--error",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("registration.dateOfBirthError")
                        ) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "rb-fieldrow gender-fieldgroup" }, [
        _c("h5", { staticClass: "gender-fieldgroup__title" }, [
          _vm._v(_vm._s(_vm.translation("registration.gender")) + ":"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "gender-fieldgroup__buttons" },
          [
            _c("rb-radio", {
              attrs: {
                id: "gender",
                name: "gender",
                "radio-value": "M",
                title: _vm.translation("registration.male"),
                validation: _vm.$v.gender,
              },
            }),
            _vm._v(" "),
            _c("rb-radio", {
              attrs: {
                id: "gender",
                name: "gender",
                "radio-value": "F",
                title: _vm.translation("newsletter_overlay.woman"),
                validation: _vm.$v.gender,
              },
            }),
            _vm._v(" "),
            _c("rb-radio", {
              attrs: {
                id: "gender",
                name: "gender",
                "radio-value": "N",
                title: _vm.translation("newsletter_overlay.unknown"),
                validation: _vm.$v.gender,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rb-newsletter-modal-content-success-form__buttons" },
        [
          _c(
            "button",
            {
              staticClass: "rb-btn",
              attrs: { "data-element-id": "X_X_HolidayOverlay_SaveProfile" },
              on: { click: _vm.onSaveClick },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.translation("newsletter_overlay.save")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "rb-btn rb-btn--white-outline",
              attrs: { "data-analytics_available_call": "0" },
              on: { click: _vm.onContinueToRaybanClick },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.translation("newsletter_overlay.continue_to_rayban")
                  ) +
                  "\n    "
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }